import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import PrivacyPolicyContent from '../../../components/PrivacyPolicyContent/PrivacyPolicyContent';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="vopub-app" style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '80px'
    }}>
      <Header />
      <main style={{
        flex: 1,
        margin: '0 auto',
        maxWidth: '800px',
        width: '100%',
        padding: '0 1rem 1rem',
        color: '#333',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}>
        <PrivacyPolicyContent prefix="privacyVoPub" />
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;